var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"popupView",staticClass:"popup-view",style:({ left: _vm.leftPos + _vm.left + 'px', top: _vm.topPos + _vm.top + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }